import { PageController } from '@client/components/_core/layout/PageController';
import { HostedLodgementFlow } from '@client/components/lodgement/hosted/HostedLodgementFlow';
import { HostedNotice, HostedShell } from '@client/components/lodgement/hosted/HostedShell';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

const searchSchema = z.object({
    accessKey: z
        .string()
        .regex(/^[A-Za-z0-9_-]{43}$/)
        .optional()
        .catch(undefined),
});

/** Opened from the "finish later" link or the resume email: the access key travels in `?accessKey=`,
 * a query name the telemetry redaction strips before any URL leaves the browser. */
export const Route = createFileRoute('/lodge/resume/$publicId')({
    validateSearch: zodValidator(searchSchema),
    component: LodgeResume,
});

function LodgeResume() {
    const { publicId } = Route.useParams();
    const { accessKey } = Route.useSearch();

    return (
        <PageController route={Route}>
            {accessKey ? (
                <HostedLodgementFlow key={publicId} source={{ kind: 'draft', access: { publicId, accessKey } }} />
            ) : (
                <HostedShell branding={null}>
                    <HostedNotice title="This link isn't valid">
                        Use the full resume link you copied or received by email.
                    </HostedNotice>
                </HostedShell>
            )}
        </PageController>
    );
}
